import { SessionStorage } from 'app/storage/session.storage';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AssociationsService } from 'app/services/associations.service';
import { AssociationHelper } from 'app/storage/association.storage';
import { lastValueFrom } from 'rxjs';
import { MeetingFormService } from '../../meeting-form.service';

@Component({
  selector: 'form-summary',
  templateUrl: './form-summary.html',
  styleUrls: ['../../meeting-form.component.scss', '../form-steps.scss', './form-summary.scss']
})
export class FormSummary implements OnInit {

  objectKeys = Object.keys;
  @Input() data: {[index:string]:any} = {}
  summary: {[index:string]:any} = {}
  loading: boolean = true
  form: FormGroup
  @Input() report:boolean  = true
  surveyStep: number = 0
  surveyKind: 'meeting' | 'advice' | '' = ''
  opened: boolean = true

  constructor(
    private meetingService: MeetingFormService,
    private service: AssociationsService,
    private route: ActivatedRoute,
    private helper: AssociationHelper,
    private fb: FormBuilder,
    public auth: SessionStorage,
    private router: Router
  ) {
    this.form = this.fb.group({})
  }

  async ngOnInit() {
    var data = Object.keys(this.route.snapshot.data).length ? this.route.snapshot.data : this.data

    if('report' in data){
      this.report = data['report']
    }
    if('survey_step' in data) this.surveyStep = data['survey_step']
    if('survey_kind' in data) this.surveyKind = data['survey_kind']
    // PSS closure (slot 5) is not a meeting, so no per-meeting project feedback there
    if(this.helper.isPss() && this.surveyStep == 5) this.surveyStep = 0

    switch(data['form']){
      case "report":
        this.summary = this.meetingService.getReportSubmit()
        break
      case "project_survey_advice":
        this.summary = this.meetingService.getProjectAdviceFormSubmit()
        break
      case "survey":
        if(this.auth.isProjectBoard() || this.auth.isCallManager()){
          if(data['user'] == 'epe'){
            var response = await lastValueFrom(this.service.getEpeSurveyForm(this.helper.getSelectedProject(), this.helper.getSelectedEpe()), {defaultValue: null})
          }
          else{
            var response = await lastValueFrom(this.service.getProjectSurveyForm(this.helper.getSelectedProject(), this.helper.getSelectedEpe()), {defaultValue: null})
          }
        }
        else if(this.auth.isProject()){
          var response = await lastValueFrom(this.service.getProjectSurveyForm(this.helper.getSelectedProject(), this.helper.getSelectedEpe()), {defaultValue: null})
        }
        else if(this.auth.isEpe()){
          var response = await lastValueFrom(this.service.getEpeSurveyForm(this.helper.getSelectedProject(), this.helper.getSelectedEpe()), {defaultValue: null})
        }
        else{
          response = null
        }

        if(!response){
          this.loading = false
          return
        }

        if(this.auth.isProjectBoard() || this.auth.isCallManager()){
          this.summary = data['user'] == 'epe' ? response['epe_survey'] : response['project_survey']
        }
        else if(this.auth.isProject()){
          this.summary = response['project_survey']
          if(!this.summary){
            this.router.navigateByUrl(`form/(meeting-form:survey-form)`)
          }
        }
        else if(this.auth.isEpe()){
          this.summary = response['epe_survey']
        }
        break
      default:
        this.summary = this.meetingService.getSubmit()
        break
    }

    this.loading = false
  }

  getKeys(): any[] {
    return Object.keys(this.summary)
  }

  humanizeKey(key: string): string {
    if(!key) return ''
    return key
      .replace(/[_\-]+/g, ' ')
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/^./, c => c.toUpperCase())
  }

}
